export var HdsIconlibraryMisc_16px;
(function (HdsIconlibraryMisc_16px) {
    HdsIconlibraryMisc_16px["AddAddressNumberSolid_16px"] = "add-address-number_solid_16px";
    HdsIconlibraryMisc_16px["AddressNumberSolid_16px"] = "address-number_solid_16px";
    HdsIconlibraryMisc_16px["BuildingHomeSolid_16px"] = "building-home_solid_16px";
    HdsIconlibraryMisc_16px["BuildingOffSolid_16px"] = "building-off_solid_16px";
    HdsIconlibraryMisc_16px["BuildingOfficeSolid_16px"] = "building-office_solid_16px";
    HdsIconlibraryMisc_16px["CalculatorSolid_16px"] = "calculator_solid_16px";
    HdsIconlibraryMisc_16px["CartSolid_16px"] = "cart_solid_16px";
    HdsIconlibraryMisc_16px["CodeSolid_16px"] = "code_solid_16px";
    HdsIconlibraryMisc_16px["CreditCardSolid_16px"] = "credit-card_solid_16px";
    HdsIconlibraryMisc_16px["DatasetSolid_16px"] = "dataset_solid_16px";
    HdsIconlibraryMisc_16px["ElevatorSolid_16px"] = "elevator_solid_16px";
    HdsIconlibraryMisc_16px["EnvironmentSolid_16px"] = "environment_solid_16px";
    HdsIconlibraryMisc_16px["EscalatorSolid_16px"] = "escalator_solid_16px";
    HdsIconlibraryMisc_16px["EscalatorDownSolid_16px"] = "escalator-down_solid_16px";
    HdsIconlibraryMisc_16px["EscalatorUpSolid_16px"] = "escalator-up_solid_16px";
    HdsIconlibraryMisc_16px["ExpertSolid_16px"] = "expert_solid_16px";
    HdsIconlibraryMisc_16px["FamilySolid_16px"] = "family_solid_16px";
    HdsIconlibraryMisc_16px["FlashlightSolid_16px"] = "flashlight_solid_16px";
    HdsIconlibraryMisc_16px["GlobalSolid_16px"] = "global_solid_16px";
    HdsIconlibraryMisc_16px["HandshakeSolid_16px"] = "handshake_solid_16px";
    HdsIconlibraryMisc_16px["HardDriveSolid_16px"] = "hard-drive_solid_16px";
    HdsIconlibraryMisc_16px["HeadphonesSolid_16px"] = "headphones_solid_16px";
    HdsIconlibraryMisc_16px["InboxSolid_16px"] = "inbox_solid_16px";
    HdsIconlibraryMisc_16px["InboxAttentionSolid_16px"] = "inbox-attention_solid_16px";
    HdsIconlibraryMisc_16px["KeySolid_16px"] = "key_solid_16px";
    HdsIconlibraryMisc_16px["KitchenSolid_16px"] = "kitchen_solid_16px";
    HdsIconlibraryMisc_16px["LaboratorySolid_16px"] = "laboratory_solid_16px";
    HdsIconlibraryMisc_16px["ManSolid_16px"] = "man_solid_16px";
    HdsIconlibraryMisc_16px["MeetingPointSolid_16px"] = "meeting-point_solid_16px";
    HdsIconlibraryMisc_16px["NeighbourhoodSolid_16px"] = "neighbourhood_solid_16px";
    HdsIconlibraryMisc_16px["PacemakerSolid_16px"] = "pacemaker_solid_16px";
    HdsIconlibraryMisc_16px["PeopleSolid_16px"] = "people_solid_16px";
    HdsIconlibraryMisc_16px["PoopSolid_16px"] = "poop_solid_16px";
    HdsIconlibraryMisc_16px["ProjectSolid_16px"] = "project_solid_16px";
    HdsIconlibraryMisc_16px["ProjectsSolid_16px"] = "projects_solid_16px";
    HdsIconlibraryMisc_16px["ReusableSolid_16px"] = "reusable_solid_16px";
    HdsIconlibraryMisc_16px["ServiceSolid_16px"] = "service_solid_16px";
    HdsIconlibraryMisc_16px["SparklesSolid_16px"] = "sparkles_solid_16px";
    HdsIconlibraryMisc_16px["SparklesMicrophoneSolid_16px"] = "sparkles-microphone_solid_16px";
    HdsIconlibraryMisc_16px["StairsSolid_16px"] = "stairs_solid_16px";
    HdsIconlibraryMisc_16px["StopwatchSolid_16px"] = "stopwatch_solid_16px";
    HdsIconlibraryMisc_16px["SuitcaseSolid_16px"] = "suitcase_solid_16px";
    HdsIconlibraryMisc_16px["TerrainSolid_16px"] = "terrain_solid_16px";
    HdsIconlibraryMisc_16px["TicketBarrierSolid_16px"] = "ticket-barrier_solid_16px";
    HdsIconlibraryMisc_16px["TrophySolid_16px"] = "trophy_solid_16px";
    HdsIconlibraryMisc_16px["VoiceCommandSolid_16px"] = "voice-command_solid_16px";
    HdsIconlibraryMisc_16px["WheelchairSolid_16px"] = "wheelchair_solid_16px";
    HdsIconlibraryMisc_16px["WomanSolid_16px"] = "woman_solid_16px";
})(HdsIconlibraryMisc_16px = HdsIconlibraryMisc_16px || (HdsIconlibraryMisc_16px = {}));
export const HDS_ICONLIBRARY_MISC_16PX_CODEPOINTS = {
    [HdsIconlibraryMisc_16px.AddAddressNumberSolid_16px]: '61697',
    [HdsIconlibraryMisc_16px.AddressNumberSolid_16px]: '61698',
    [HdsIconlibraryMisc_16px.BuildingHomeSolid_16px]: '61699',
    [HdsIconlibraryMisc_16px.BuildingOffSolid_16px]: '61700',
    [HdsIconlibraryMisc_16px.BuildingOfficeSolid_16px]: '61701',
    [HdsIconlibraryMisc_16px.CalculatorSolid_16px]: '61702',
    [HdsIconlibraryMisc_16px.CartSolid_16px]: '61703',
    [HdsIconlibraryMisc_16px.CodeSolid_16px]: '61704',
    [HdsIconlibraryMisc_16px.CreditCardSolid_16px]: '61705',
    [HdsIconlibraryMisc_16px.DatasetSolid_16px]: '61706',
    [HdsIconlibraryMisc_16px.ElevatorSolid_16px]: '61707',
    [HdsIconlibraryMisc_16px.EnvironmentSolid_16px]: '61708',
    [HdsIconlibraryMisc_16px.EscalatorSolid_16px]: '61709',
    [HdsIconlibraryMisc_16px.EscalatorDownSolid_16px]: '61710',
    [HdsIconlibraryMisc_16px.EscalatorUpSolid_16px]: '61711',
    [HdsIconlibraryMisc_16px.ExpertSolid_16px]: '61712',
    [HdsIconlibraryMisc_16px.FamilySolid_16px]: '61713',
    [HdsIconlibraryMisc_16px.FlashlightSolid_16px]: '61714',
    [HdsIconlibraryMisc_16px.GlobalSolid_16px]: '61715',
    [HdsIconlibraryMisc_16px.HandshakeSolid_16px]: '61716',
    [HdsIconlibraryMisc_16px.HardDriveSolid_16px]: '61717',
    [HdsIconlibraryMisc_16px.HeadphonesSolid_16px]: '61718',
    [HdsIconlibraryMisc_16px.InboxSolid_16px]: '61719',
    [HdsIconlibraryMisc_16px.InboxAttentionSolid_16px]: '61720',
    [HdsIconlibraryMisc_16px.KeySolid_16px]: '61721',
    [HdsIconlibraryMisc_16px.KitchenSolid_16px]: '61722',
    [HdsIconlibraryMisc_16px.LaboratorySolid_16px]: '61723',
    [HdsIconlibraryMisc_16px.ManSolid_16px]: '61724',
    [HdsIconlibraryMisc_16px.MeetingPointSolid_16px]: '61725',
    [HdsIconlibraryMisc_16px.NeighbourhoodSolid_16px]: '61726',
    [HdsIconlibraryMisc_16px.PacemakerSolid_16px]: '61727',
    [HdsIconlibraryMisc_16px.PeopleSolid_16px]: '61728',
    [HdsIconlibraryMisc_16px.PoopSolid_16px]: '61729',
    [HdsIconlibraryMisc_16px.ProjectSolid_16px]: '61730',
    [HdsIconlibraryMisc_16px.ProjectsSolid_16px]: '61731',
    [HdsIconlibraryMisc_16px.ReusableSolid_16px]: '61732',
    [HdsIconlibraryMisc_16px.ServiceSolid_16px]: '61733',
    [HdsIconlibraryMisc_16px.SparklesSolid_16px]: '61734',
    [HdsIconlibraryMisc_16px.SparklesMicrophoneSolid_16px]: '61735',
    [HdsIconlibraryMisc_16px.StairsSolid_16px]: '61736',
    [HdsIconlibraryMisc_16px.StopwatchSolid_16px]: '61737',
    [HdsIconlibraryMisc_16px.SuitcaseSolid_16px]: '61738',
    [HdsIconlibraryMisc_16px.TerrainSolid_16px]: '61739',
    [HdsIconlibraryMisc_16px.TicketBarrierSolid_16px]: '61740',
    [HdsIconlibraryMisc_16px.TrophySolid_16px]: '61741',
    [HdsIconlibraryMisc_16px.VoiceCommandSolid_16px]: '61742',
    [HdsIconlibraryMisc_16px.WheelchairSolid_16px]: '61743',
    [HdsIconlibraryMisc_16px.WomanSolid_16px]: '61744',
};
//# sourceMappingURL=hds-iconlibrary-misc-16px.js.map